import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=213ba69c&scoped=true&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"
import style0 from "./VCard.vue?vue&type=style&index=0&id=213ba69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ba69c",
  null
  
)

component.options.__file = "VCard.vue"
export default component.exports